// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__D-_T_"};